import(/* webpackMode: "eager" */ "/runner/_work/cosmos-src/cosmos-src/websites/legalhub-website/src/app/global-error.tsx");
